"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { cn } from "~/lib/utils";
import { buttonVariants } from "~/components/ui/button";

interface StickyQuizCTAProps {
  quizId: string;
  quizTitle: string;
  duration: string;
  questionCount: number;
  ctaLabel: string;
}

export function StickyQuizCTA({
  quizId,
  quizTitle,
  duration,
  questionCount,
  ctaLabel,
}: StickyQuizCTAProps) {
  const [showStickyButton, setShowStickyButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = 600; // Approximate hero section height
      setShowStickyButton(window.scrollY > heroHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!showStickyButton) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 p-4 backdrop-blur-xs supports-backdrop-filter:bg-background/60">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
        <div className="hidden min-w-0 flex-1 sm:block">
          <h3 className="truncate font-semibold">{quizTitle}</h3>
          <p className="truncate text-sm text-muted-foreground">
            {duration} • {questionCount} pitanja
          </p>
        </div>
        <Link
          href={`/testovi/${quizId}/odgovori`}
          className={cn(
            buttonVariants({ variant: "cta", size: "lg" }),
            "w-full shrink-0 sm:w-auto",
          )}
          aria-label={`${ctaLabel} - ${quizTitle}`}
        >
          {ctaLabel}
          <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
